import styled from "styled-components";

export const ServicesMainWrapper = styled.div``;
